import type { MutableRefObject } from 'react';
import { ClipboardList } from 'lucide-react';
import type { TodoWithSource } from '../../types/todo';
import { groupTodosWithSource } from '../../services/todoService';
import { ToDoGroup } from './ToDoGroup';

interface ToDoListProps {
  todos: TodoWithSource[];
  onToggle: (id: string, completed: boolean) => void;
  onDelete: (id: string) => void;
  onEdit: (todo: TodoWithSource) => void;
  focusedTodoId?: string | null;
  todoRefs?: MutableRefObject<Map<string, HTMLDivElement>>;
}

export function ToDoList({ todos, onToggle, onDelete, onEdit, focusedTodoId, todoRefs }: ToDoListProps) {
  const groupedTodos = groupTodosWithSource(todos);

  if (todos.length === 0) {
    return (
      <div className="bg-white rounded-2xl border border-gray-100 p-8 text-center">
        <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <ClipboardList className="w-8 h-8 text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-[#1A1A1A] mb-2">Keine Aufgaben</h3>
        <p className="text-[#6B6B6B]">
          Erstelle deine erste Aufgabe, um loszulegen.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {groupedTodos.map(({ group, todos: groupTodos }) => (
        <ToDoGroup
          key={group}
          group={group}
          todos={groupTodos}
          onToggle={onToggle}
          onDelete={onDelete}
          onEdit={onEdit}
          focusedTodoId={focusedTodoId}
          todoRefs={todoRefs}
        />
      ))}
    </div>
  );
}
